import { config } from '../../utilities/config';
import keycloak from '../../keycloak';

export async function fetchBusinessMeasuresApi(organizationId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/business-measure`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    }
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

export async function createBusinessMeasureApi(organizationId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/business-measure`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function editBusinessMeasureApi(organizationId, businessMeasureId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/business-measure/${businessMeasureId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}
